import React, { Component } from 'react';
export default class GoogleAd extends Component {
  componentDidMount() {
    // load the google ad script if it hasn't been loaded yet.
    const googleAdScript = document.getElementById('googleAds');
    if (!googleAdScript) {
      const elem = document.createElement("script");
      elem.src = "//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
      elem.async = true;
      elem.defer = true;
      elem.id = "googleAds";
      document.body.insertBefore(elem, document.body.firstChild);
    }
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }
  render () {
    return (
      <ins
        contentEditable={false}
        className="adsbygoogle"
        style={{display:'block'}}
        data-ad-client={process.env.REACT_APP_GOOGLE_AD_PUB}
        data-ad-slot={process.env.REACT_APP_GOOGLE_AD_SLOT_ID}
        data-ad-format="auto"
        // data-adtest="on"
        data-full-width-responsive="true"
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Marketing/GoogleAd.js